import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import aphroditePlugin from "./plugins/aphrodite";
import VueHighlightJS from "vue-highlightjs";
import "../assets/scss/styles.scss";
import { widgetUrl } from "./environment";

Vue.config.productionTip = false;

Vue.use(aphroditePlugin);
Vue.use(VueHighlightJS);

const scriptEle = document.createElement('script');
scriptEle.setAttribute('src', widgetUrl);
document.head.appendChild(scriptEle);

scriptEle.addEventListener('load', function () {
	new Vue({
		router,
		store,
		render: (h) => h(App)
	}).$mount("#app");
});

